import { Subject } from "rxjs";
import { Logger } from "../../../02_utils/logger";
import { Utils } from "../../../02_utils/utils";


export class ChipService {
  private filter: HTMLElement;
  private chipOutput: HTMLElement;
  private chipDummy: HTMLElement;
  private chipResetDummy: HTMLElement;

  public currentFilters: {[key: string]: any} = {};
  public filters: Subject<{[key: string]: any}> = new Subject<{[key: string]: any}>();

  constructor(
    filter: HTMLElement,
    private $log: Logger,
    private $utils: Utils
  ) {
    this.filter = filter;
    this.chipOutput = this.filter.querySelector('[data-chip-output]');
    this.chipDummy = this.filter.querySelector('[data-chip-dummy]');
    this.chipResetDummy = this.filter.querySelector('[data-chip-reset-dummy]');
  }

  public updateChips() {
    if (!this.chipOutput) {
      return;
    }

    this.chipOutput.innerHTML = '';
    let chipsActive = false;

    Object.entries(this.currentFilters)?.forEach(entry => {
      const [key, value] = entry;

      if (key === 'orderBy' ||  !!!value || (Array.isArray(value) && value.length == 0)) {
        return;
      }

      chipsActive = true;

      if (Array.isArray(value)) {
        value.forEach(value => {
          this.createChip(value, key);
        });
        return;
      } else if (value) {
        this.createChip(value, key);
      }
    });

    if (chipsActive) {
      this.$utils.addOrRemoveClases('remove', 'd-none', this.chipOutput);
      const reset = this.chipResetDummy.cloneNode(true) as HTMLElement;
      this.$utils.addOrRemoveClases('remove', 'd-none', reset);
      reset.removeAttribute('data-chip-reset-dummy');
      reset.removeAttribute('disabled');

      this.chipOutput.appendChild(reset);

      reset?.addEventListener('click', () => {
        this.currentFilters = {
          orderBy: this.currentFilters.orderBy
        }

        this.filters.next(this.currentFilters);
      });
    } else {
      this.$utils.addOrRemoveClases('add', 'd-none', this.chipOutput);
    }
  }

  private createChip(value: string, key: string) {
    const input: HTMLInputElement = this.filter.querySelector(`[value="${value}"]`) ?? this.filter.querySelector(`[name="${key}"], [data-name="${key}"]`);

    if (!input) {
      return;
    }

    const type: string = input?.dataset.type ?? input?.type;
    let chipText: string = input?.value;

    if (type == 'checkbox' || type == 'radio') {
      const label = this.filter.querySelector(`label[for="${input?.id}"]`) as HTMLElement;

      chipText = label?.innerText;
    } else if (type == 'select') {
      const select = this.filter.querySelector(`[data-name="${key}"]`);
      const option = select?.parentElement?.querySelector(`.js-select-option[data-value="${value}"]`) as HTMLElement;

      chipText = option?.innerText;
    } else {
      const label = this.filter.querySelector(`label[for="${input?.id}"]`) as HTMLElement;

      chipText = label?.innerText ?? input.getAttribute('aria-label') + ': ' + input?.value;
    }

    const dummy = this.chipDummy.cloneNode(true) as HTMLElement;
    const span = document.createElement('span');

    span.innerHTML = chipText;
    dummy.append(span);
    this.$utils.addOrRemoveClases('remove', 'd-none', dummy);
    dummy.removeAttribute('data-chip-dummy');
    dummy.removeAttribute('tabindex');
    dummy.setAttribute('data-id', input.id);

    this.chipOutput.appendChild(dummy);

    dummy.addEventListener('click', () => {
      if (Array.isArray(this.currentFilters[key])) {
        const index = this.currentFilters[key].findIndex(x => x == value);
        this.currentFilters[key].splice(index, 1);
      } else {
        delete this.currentFilters[key];
      }

      this.filters.next(this.currentFilters);
    });
  }
}
